import { GameBrief } from "./games_types"
import { ImageType } from "./genericTypes.types"
import { Genre } from "./genres"

export const RowContentType = {
  NoContent: 0,
  Custom: 1,
  Genre: 2,
  KeepPlaying: 3,
  Favorites: 4,
  YouMightLike: 5,
  MostPopular: 6,
  GameDrop: 7,
} as const;

export type RowContentType =
  (typeof RowContentType)[keyof typeof RowContentType];

export const RowStyle = {
  Invisible: 0,
  Inherited: 1,
  HorizontalCards: 2,
  VerticalCards: 3,
  TwoRowsWithLeadingContent: 4,
  RoundCards: 5,
  Spotlight: 6
}

export type RowStyle =
  (typeof RowStyle)[keyof typeof RowStyle];

export type Row = {
  id: string
  title: string
  spotlight_text: string
  subtitle: string
  content_type: RowContentType
  genre: Genre | null
  style: RowStyle
  special_page_background: string
  background?: ImageType | null
  icon: string
  show_more: number
  show_more_action: string
  content: GameBrief[]
  supress_labels: string[] | null
}